function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u8CBC\\u5716",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11,17.5 C11,21.0841 13.9159,24 17.5,24 C21.0841,24 24,21.0841 24,17.5 C24,13.9159 21.0841,11 17.5,11 C13.9159,11 11,13.9159 11,17.5 Z",
  id: "basic-/-happy",
  fill: "#E89A4F",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "sidebar-\\u8CBC\\u5716"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "basic-/-happy-(Background/Mask)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2,12 C2,17.5139999 6.48600006,22 12,22 C17.5139999,22 22,17.5139999 22,12 C22,6.48600006 17.5139999,2 12,2 C6.48600006,2 2,6.48600006 2,12 Z M4,12 C4,7.58900023 7.58900023,4 12,4 C16.4109998,4 20,7.58900023 20,12 C20,16.4109998 16.4109998,20 12,20 C7.58900023,20 4,16.4109998 4,12 Z M10,10.5 C10,9.67157286 9.32842708,9 8.5,9 C7.67157286,9 7,9.67157286 7,10.5 C7,11.3284271 7.67157286,12 8.5,12 C9.32842708,12 10,11.3284271 10,10.5 Z M16.9860001,10.493 C16.9860001,9.66843891 16.3175611,9 15.493,9 C14.6684389,9 14,9.66843891 14,10.493 C14,11.3175611 14.6684389,11.9860001 15.493,11.9860001 C16.3175611,11.9860001 16.9860001,11.3175611 16.9860001,10.493 Z M17,14 L7,14 C7.66666667,16.6666667 9.33333333,18 12,18 C14.6666667,18 16.3333333,16.6666667 17,14 Z",
  id: "basic-/-happy",
  fill: "#282C34",
  mask: "url(#mask-2)"
})));

function SvgSidebarStickerB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8CBC\u5716") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarStickerB);
export default __webpack_public_path__ + "static/media/sidebar_sticker-b.d4050376.svg";
export { ForwardRef as ReactComponent };